import { calculateSelection, cartEndpoint } from './commerce.js';

const config = JSON.parse(document.getElementById('StoreConfig')?.textContent || '{"root":"/","cart":"/cart","currency":"USD","locale":"en"}');
const money = cents => new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency }).format(Number(cents) / 100);
const q = (selector, root = document) => root.querySelector(selector);
const qa = (selector, root = document) => [...root.querySelectorAll(selector)];
const api = async (endpoint, data) => {
  const response = await fetch(cartEndpoint(config.root, endpoint), {
    method: data ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    ...(data ? { body: JSON.stringify(data) } : {})
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.description || result.message || 'Please try again.');
  return result;
};
let lastFocus;
function openDialog(dialog) { if (!dialog) return; lastFocus = document.activeElement; if(!dialog.open) dialog.showModal(); }
function closeDialog(dialog) { dialog?.close(); lastFocus?.focus(); }
document.addEventListener('click', event => {
  const close = event.target.closest('[data-dialog-close]');
  if (close) closeDialog(close.closest('dialog'));
  const opener = event.target.closest('[data-dialog-open]');
  if (opener) openDialog(document.getElementById(opener.dataset.dialogOpen));
  const cart = event.target.closest('[data-cart-open]');
  if (cart) { event.preventDefault(); openCart(); }
  if (event.target instanceof HTMLDialogElement) {
    const box = event.target.getBoundingClientRect();
    if(event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDialog(event.target);
  }
});

function initializeProduct(section) {
  if (section.dataset.ready || !q('[data-product-data]', section)) return;
  section.dataset.ready = 'true';
  const data = JSON.parse(q('[data-product-data]', section).textContent);
  const variants = data.variants;
  const form = q('[data-product-form]', section);
  const addButton = q('[data-add-button]', section);
  let hero = q('.gallery-main img', section);
  const thumbs = q('[data-gallery-thumbs]', section);
  let quantity = Number(q('input[name=quantity]:checked',section)?.value || 1), galleryIndex = 0, pending = false;
  let galleryItems = qa('[data-gallery-image]', section).map(button=>({image:button.dataset.galleryImage,title:hero?.alt || '',id:null}));
  if (!data.singleProduct) {
    const seen = new Set();
    galleryItems = variants.filter(v=>v.image && !seen.has(v.image) && seen.add(v.image)).map(v=>({image:v.image,title:v.title,id:v.id}));
    thumbs.replaceChildren();
    galleryItems.forEach((item, index) => {
      const button = document.createElement('button'); button.type='button'; button.dataset.galleryImage=item.image;
      button.setAttribute('aria-label',item.title);button.setAttribute('aria-pressed',String(index===0));
      const image=document.createElement('img');image.src=item.image;image.alt=item.title;image.loading='lazy';button.append(image);thumbs.append(button);
    });
  }
  const row = () => q(`[data-bundle="${quantity}"]`,section);
  const selectors = () => qa('[data-variant-select]',row());
  const selections = () => selectors().map(select=>select.value);
  const extraItems = () => {
    const extras = [];
    const addon = q('[data-addon]:checked',section);
    if(addon) extras.push({id:addon.value,price:Number(addon.dataset.price),available:true});
    qa('[data-gift]',section).forEach(gift=>{
      if (quantity >= Number(gift.dataset.min) && gift.dataset.available === 'true') extras.push({id:gift.dataset.variantId,price:Number(gift.dataset.price),available:true});
    });
    return extras;
  };
  function showImage(index, syncSelection = false) {
    if(!galleryItems.length) return;
    galleryIndex = (index + galleryItems.length) % galleryItems.length;
    const item=galleryItems[galleryIndex];
    if(!hero) {hero=document.createElement('img');q('.gallery-main svg',section)?.remove();q('.gallery-main',section).prepend(hero);}
    if(hero) {hero.src=item.image;hero.removeAttribute('srcset');hero.alt=item.title;}
    qa('[data-gallery-image]',section).forEach((b,i)=>b.setAttribute('aria-pressed',String(i===galleryIndex)));
    if(syncSelection && item.id) {
      const variant=variants.find(v=>v.id===item.id);
      if(variant) { selectors()[0].value=String(item.id);update(); }
    }
  }
  function update() {
    qa('[data-bundle]',section).forEach(bundle=>{
      const active=Number(bundle.dataset.bundle)===quantity;
      bundle.classList.toggle('is-selected',active);q('.bundle-options',bundle).hidden=!active;
      const rowIds=qa('[data-variant-select]',bundle).map(s=>s.value);
      const rowVariant=variants.find(v=>String(v.id)===rowIds[0]);
      const bundleProduct=q('[data-bundle-product]',bundle);
      if(bundleProduct) bundleProduct.textContent=rowVariant?.productTitle || '';
      const selection=calculateSelection(rowIds,variants);
      q('[data-bundle-price]',bundle).textContent=money(selection.price);
      const compare=q('[data-bundle-compare]',bundle);compare.textContent=money(selection.compare);compare.hidden=selection.compare<=selection.price;
    });
    const selected=variants.find(v=>String(v.id)===selectors()[0]?.value);
    if(selected) {
      const description=q('[data-product-description]',section);if(description)description.innerHTML=selected.description || '';
      q('[data-product-title]',section).textContent=data.singleProduct?selected.productTitle:selected.title;
      q('[data-product-price]',section).textContent=money(selected.price);
      const compare=q('[data-product-compare]',section);compare.textContent=money(selected.compare);compare.hidden=selected.compare<=selected.price;
      const sale=q('[data-sale-label]',section);sale.hidden=selected.compare<=selected.price;
      if(!sale.hidden) sale.textContent=`SAVE ${Math.round((1-selected.price/selected.compare)*100)}%`;
      selectors().forEach(select=>{
        const v=variants.find(x=>String(x.id)===select.value),image=q('img',select.closest('.variant-row'));
        if(image && v?.image) {image.src=v.image;image.removeAttribute('srcset');image.alt=v.title;}
      });
    }
    qa('[data-gift]',section).forEach(gift=>{
      const unlocked=quantity>=Number(gift.dataset.min) && gift.dataset.available==='true';
      gift.classList.toggle('is-locked',!unlocked);q('[data-gift-status]',gift).textContent=unlocked?'INCLUDED IN CART':`${gift.dataset.min}+ ITEMS`;
    });
    const selection=calculateSelection(selections(),variants,extraItems());
    addButton.disabled=pending || !selection.available;
    addButton.textContent=pending?'Adding…':selection.available?`Add to cart — ${money(selection.price)}`:'Sold out';
  }
  form.addEventListener('change',event=>{
    if(event.target.name==='quantity') {
      const previous=selections();quantity=Number(event.target.value);
      selectors().forEach((select,i)=>{if(previous[i]) select.value=previous[i];});
    }
    if(event.target.matches('[data-variant-select]')) {
      const selected=variants.find(v=>String(v.id)===event.target.value);
      const index=galleryItems.findIndex(item=>item.image===selected?.image);
      if(index>=0) showImage(index);
      if(data.singleProduct) {const url=new URL(location.href);url.searchParams.set('variant',event.target.value);history.replaceState({},'',url);}
    }
    update();
  });
  thumbs.addEventListener('click',event=>{const button=event.target.closest('[data-gallery-image]');if(button) showImage(qa('[data-gallery-image]',section).indexOf(button),true);});
  qa('[data-gallery-step]',section).forEach(button=>button.addEventListener('click',()=>showImage(galleryIndex+Number(button.dataset.galleryStep),true)));
  let touchStart;
  q('.gallery-main',section).addEventListener('touchstart',e=>touchStart=e.changedTouches[0].clientX,{passive:true});
  q('.gallery-main',section).addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-touchStart;if(Math.abs(dx)>45)showImage(galleryIndex+(dx<0?1:-1),true);},{passive:true});
  form.addEventListener('submit',async event=>{
    event.preventDefault();if(pending)return;
    const selection=calculateSelection(selections(),variants,extraItems());if(!selection.available)return;
    pending=true;update();q('[data-product-error]',section).textContent='';
    try {await api('cart/add.js',{items:selection.items}); await openCart();}
    catch(error){q('[data-product-error]',section).textContent=error.message;}
    finally{pending=false;update();}
  });
  const initialVariant=variants.find(v=>v.id===data.initial);
  const initialImage=galleryItems.findIndex(item=>item.image===initialVariant?.image);
  if(initialImage>=0)showImage(initialImage);
  update();
}
qa('[data-product-section]').forEach(initializeProduct);
document.addEventListener('shopify:section:load',event=>qa('[data-product-section]',event.target).forEach(initializeProduct));

function element(tag, className, text) {const node=document.createElement(tag);if(className)node.className=className;if(text!==undefined)node.textContent=text;return node;}
async function openCart() {
  const dialog=q('#CartDrawer');openDialog(dialog);
  q('[data-cart-error]').textContent='';
  try{renderCart(await api('cart.js'));}
  catch(error){q('[data-cart-error]').textContent=error.message;q('[data-cart-content]').replaceChildren(element('p','','Unable to load the cart.'));const link=element('a','button','View cart');link.href=config.cart;q('[data-cart-content]').append(link);}
}
function renderCart(cart) {
  qa('[data-cart-count]').forEach(n=>n.textContent=cart.item_count||'');
  const container=q('[data-cart-content]');container.replaceChildren();
  if(!cart.items.length){container.append(element('p','empty','Your cart is empty.'));return;}
  const lines=element('div','cart-lines');
  cart.items.forEach(item=>{
    const line=element('div','cart-line');
    const image=element('img');if(item.image)image.src=item.image;image.alt=item.product_title;line.append(image);
    const details=element('div');const title=element('a');title.href=item.url;title.append(element('h3','',item.product_title));details.append(title);
    if(item.variant_title)details.append(element('p','muted',item.variant_title));
    details.append(element('p','',money(item.final_line_price)));
    for(const discount of item.line_level_discount_allocations||[]) details.append(element('p','muted',discount.discount_application.title));
    const qty=element('div','cart-quantity');
    for(const [label,next] of [['−',item.quantity-1],[String(item.quantity),null],['+',item.quantity+1],['×',0]]){
      const node=element(next===null?'span':'button','',label);
      if(next!==null){node.type='button';node.setAttribute('aria-label',label==='×'?`Remove ${item.product_title}`:label==='−'?`Decrease ${item.product_title}`:`Increase ${item.product_title}`);node.addEventListener('click',()=>changeQuantity(item.key,next));}
      qty.append(node);
    }
    details.append(qty);line.append(details);lines.append(line);
  });container.append(lines);
  const total=element('div','cart-total');total.append(element('span','','Subtotal'),element('span','',money(cart.total_price)));container.append(total);
  for(const discount of cart.cart_level_discount_applications||[])container.append(element('p','muted',discount.title));
  container.append(element('p','muted','Shipping and taxes calculated at checkout.'));
  const form=element('form');form.action=config.cart;form.method='post';
  const checkout=element('button','button cart-checkout','Checkout');checkout.name='checkout';checkout.type='submit';form.append(checkout);container.append(form);
}
let changing=false;
async function changeQuantity(key,quantity){
  if(changing)return;changing=true;q('[data-cart-error]').textContent='';qa('.cart-quantity button').forEach(b=>b.disabled=true);
  try{renderCart(await api('cart/change.js',{id:key,quantity}));}
  catch(error){q('[data-cart-error]').textContent=error.message;}
  finally{changing=false;qa('.cart-quantity button').forEach(b=>b.disabled=false);}
}
document.addEventListener('change',event=>{if(event.target.matches('[data-sort]'))event.target.closest('form').requestSubmit();});

function initializeReviews(section) {
  if(section.dataset.ready)return;section.dataset.ready='true';
  const list=q('[data-review-list]',section),more=q('[data-review-more]',section),sort=q('[data-review-sort]',section);
  if(!list || !sort)return;let visible=8;
  const update=()=>{const cards=qa('[data-review]',list);cards.sort((a,b)=>sort.value==='high'?Number(b.dataset.rating)-Number(a.dataset.rating):sort.value==='low'?Number(a.dataset.rating)-Number(b.dataset.rating):Number(a.dataset.order)-Number(b.dataset.order));cards.forEach((card,i)=>{card.hidden=i>=visible;list.append(card);});if(more)more.hidden=visible>=cards.length;};
  sort.addEventListener('change',()=>{visible=8;update();});more?.addEventListener('click',()=>{visible+=8;update();});update();
}
qa('[data-reviews]').forEach(initializeReviews);
document.addEventListener('shopify:section:load',event=>qa('[data-reviews]',event.target).forEach(initializeReviews));

document.addEventListener('submit', async event => {
 const form=event.target.closest('[data-quick-add]');if(!form)return;
 event.preventDefault();const button=q('button[type=submit]',form),error=q('.form-error',form);if(button.disabled)return;
 const label=button.textContent;button.disabled=true;button.textContent='Adding…';error.textContent='';
 try{await api('cart/add.js',{items:[{id:Number(new FormData(form).get('id')),quantity:1}]});await openCart();}
 catch(e){error.textContent=e.message;}finally{button.disabled=false;button.textContent=label;}
});
document.addEventListener('keydown',event=>{if(event.key==='Escape')qa('.mobile-menu[open]').forEach(menu=>menu.removeAttribute('open'));});
document.addEventListener('click',event=>{qa('.mobile-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.removeAttribute('open');});});
